import { Resource } from '@/types/dmaker/resource.type'
import _ from 'lodash'

export default function usePrefixToFindCategoryId({
  resource,
  prefix,
}: {
  resource: { [key: number]: Resource[] }
  prefix: Resource['prefix']
}): number {
  let catId = 0
  _.each(resource, (item, id) => {
    const current = item.find((i) => i.prefix === prefix)
    if (current) {
      catId = id
    }
  })
  return Number(catId)
}
